/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useUpdateEffect } from 'react-use';
import {
  getPiboInfo,
  setGroup,
  setPiboDisturb,
  setPiboGeo,
  setPiboReaction,
  setPiboVolume,
} from '../../pibo';
import NewModal from '../NewModal';
import SliderInputForm from './SliderInputForm';
import RobotReactionInputForm from './RobotReactionInputForm';
import RobotGeoInputForm from './RobotGeoInputForm';
import RobotDisturbInputForm from './RobotDisturbInputForm';
import { getUserId, Log } from '../../common/util';
import RobotDataInitialForm from './RobotDataInitialForm';

const RobotConfigModal = ({
  open,
  items,
  // onClose,
  init,
  loading,
  result,
  onInit,
  onUpdate,
  onCancel,
}) => {
  const [itemInfo, setInfo] = useState({
    alias: null,
    serial: null,
    reaction: null,
    geo: null,
    info: null,
  });
  const {
    id: robotId,
    alias,
    serial,
    reaction,
    geo,
    info,
    disturb,
    volume,
  } = itemInfo;

  const handleVolumeChange = (v) => {
    setGroup([serial]);
    setPiboVolume(v);
    onUpdate({ volume: v, robotId });
  };

  const handleReactionChange = (v) => {
    onUpdate({ reaction: v, robotId });
    setPiboReaction(v);
  };

  const handleGeoChange = (v) => {
    onUpdate({ geo: v, robotId });
    setPiboGeo(v);
  };

  const onDisturbChange = (v) => {
    onUpdate({ disturb: { ...v, userId: getUserId() }, robotId });
    setPiboDisturb(v);
  };

  const onInitChange = (v) => {
    if (v) {
      setGroup([serial]);
      onInit(robotId);
    }
  };

  useUpdateEffect(() => {
    if (init && result) {
      if (items.length) {
        setGroup([serial]);
        setInfo({ ...items[0], info: null });
        getPiboInfo()
          .then((data) => {
            const { config } = data;
            // setInfo({ ...items[0], info: config });
            setInfo((prevState) => ({ ...prevState, info: config }));
          })
          .catch((e) => {
            Log(e);
          });
      }
    }
  }, [init, result]);

  useEffect(() => {
    if (items.length) {
      setGroup([serial]);
      setInfo({ ...items[0], info: null });
      getPiboInfo()
        .then((data) => {
          const { config } = data;
          // setInfo({ ...items[0], info: config });
          setInfo((prevState) => ({ ...prevState, info: config }));
        })
        .catch((e) => {
          Log(e);
        });
    }
  }, [items]);

  return (
    <NewModal
      open={open}
      onClose={onCancel}
      buttons={[{ label: '닫기', onClick: onCancel }]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5">
            {alias
              ? `${alias}(${serial}) 로봇 설정 변경`
              : `${serial} 로봇 설정 변경`}
          </Typography>
        </Grid>
        {/* (setError || getError) && (
                <Grid item xs={12}>
                  <Alert color="error">{setError || getError}</Alert>
                </Grid>
              ) */}
        <Grid item xs={12}>
          <SliderInputForm
            id="slider"
            name="slider"
            defaultValue={info ? info.volume : volume}
            max={100}
            min={0}
            step={1}
            onChange={(v) => handleVolumeChange(v, serial)}
            readOnly={!info}
            init={init}
          />
        </Grid>
        <Grid item xs={12}>
          <RobotReactionInputForm
            id="reaction"
            name="reaction"
            value={reaction || 0}
            onSave={handleReactionChange}
            init={init}
          />
        </Grid>
        {geo && (
          <Grid item xs={12}>
            <RobotGeoInputForm
              id="location_search"
              name="location_search"
              value={geo}
              onSave={handleGeoChange}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <RobotDisturbInputForm value={disturb} onSave={onDisturbChange} />
        </Grid>
        <Grid item xs={12}>
          <RobotDataInitialForm
            loading={init && loading}
            result={init && result}
            onSave={onInitChange}
          />
        </Grid>
      </Grid>
    </NewModal>
  );
};

export default RobotConfigModal;
